import React from "react";
import {
  handleChange,
  handleChangeNameValue,
} from "../../../helpers/handleFormChanges";
import CommonModal from "../../../components/Common/CommonModal";
import CommonButton from "../../../components/buttons/CommonButton";
import CommonInput from "../../../components/forms/CommonInput";
import CommonInputValor from "../../../components/forms/CommonInputValor";
import PropTypes from "prop-types";

function EditarReajusteModal({
  isOpen,
  setIsOpen,
  valuesHook,
  editarReajuste,
}) {
  const { values, setValues } = valuesHook;

  return (
    <CommonModal
      title={"Editar solicitação de reajuste de salário"}
      is_open_modal={isOpen}
      set_is_open_modal={setIsOpen}
      size="xl"
      buttons={
        <CommonButton
          key={`editar-reajuste`}
          onClick={editarReajuste}
          color="primary"
        >
          Editar solicitação
        </CommonButton>
      }
    >
      <div className="row">
        <div className="col-md-4 mb-3">
          <CommonInputValor
            label="Salário atual"
            id="salario_atual"
            value={values.salario_atual}
            onChange={(e) => {
              handleChangeNameValue(
                "salario_atual",
                e.target.value,
                values,
                setValues
              );
            }}
            required
            disabled
          />
        </div>
        <div className="col-md-4 mb-3">
          <CommonInputValor
            label="Novo salário"
            id="novo_salario"
            value={values.novo_salario}
            onChange={(e) => {
              handleChangeNameValue(
                "novo_salario",
                e.target.value,
                values,
                setValues
              );
            }}
            required
          />
        </div>
        <div className="col-md-4 mb-3">
          <CommonInput
            label="Mês do reajuste"
            id="mes_reajuste"
            value={values.mes_reajuste}
            onChange={(e) => {
              handleChange(e, values, setValues);
            }}
            type="month"
            hint="O mês de referência é o período em que o trabalho foi realizado e serve como base para calcular o pagamento dos colaboradores. Normalmente, o pagamento é feito até o quinto dia útil do mês seguinte."
            required
          />
        </div>
      </div>
    </CommonModal>
  );
}

EditarReajusteModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  setIsOpen: PropTypes.func.isRequired,
  valuesHook: PropTypes.shape({
    values: PropTypes.object.isRequired,
    setValues: PropTypes.func.isRequired,
  }).isRequired,
  editarReajuste: PropTypes.func.isRequired,
};

export default EditarReajusteModal;
